import React, { useEffect, useMemo, useState } from "react";
import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";


import {
  ShieldCheck,
  FileText,
  IndianRupee,
  Edit3,
  Link2,
  Eye,
} from "lucide-react";
import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import RegularLoader from "../../../../Component/Loader/RegularLoader";
import Pagination from "../../../../Component/Common/Pagination";
import RefreshButton from "../../../../Component/Common/RefreshButton";
import { BASE_URL, Warrenty_URL } from "../../../../config/api";
import SimpleTable from "../../../../Component/Common/SimpleTable";

import ExpandableCard from "../../../../Component/Common/ExpandableCard";
import toast from "react-hot-toast";
import BlueButton from "../../../../Component/Common/BlueButton";
import KpiSection from "./KpiSection";
import WarrantyTable from "./WarrantyTable";
import ClaimsTable from "./ClaimsTable";
import ClaimConsole from "./ClaimAdminConsole";
import AssignEmployeeModal from "./AssignEmployeeModal";
import ApproveRejectModal from "./ApproveRejectModal";
import { Badge } from "../../../../Component/RetailerMainComponents/Badge";
import { formatDateTime } from "../../../../Component/Common/formatDateTime";
import axios from "axios";


const claims = [
  {
    id: "CLM-5001",
    warrantyId: "WAR-1001",
    retailer: "Shree Mobile Store",
    customer: "Amit Kulkarni",
    device: "Samsung A55",
    raisedBy: "Retailer", // Retailer | Customer
    issue: "Device not powering on",
    status: "Pending", // Pending | Approved | Rejected | In Progress | Settled
    reason: "",
    approvedAmount: 3500,
    payableAmount: 3000,
    payableStatus: "Pending",
    paymentLink: "",
    lastUpdated: "2025-10-15",
  },
  {
    id: "CLM-5002",
    warrantyId: "WAR-0998",
    retailer: "Digital Zone",
    customer: "Demo Customer",
    device: "mPOS Demo",
    raisedBy: "Customer",
    issue: "Screen flickering",
    status: "Rejected",
    reason: "Warranty expired",
    approvedAmount: 0,
    payableAmount: 0,
    payableStatus: "Not Applicable",
    paymentLink: "",
    lastUpdated: "2025-01-07",
  },
  {
    id: "CLM-5003",
    warrantyId: "WAR-1002",
    retailer: "A1 Electronics",
    customer: "Riya Shah",
    device: "Samsung Tab S9",
    raisedBy: "Customer",
    issue: "No sound from speakers",
    status: "Approved",
    reason: "",
    approvedAmount: 2200,
    payableAmount: 2000,
    payableStatus: "Paid",
    paymentLink: "https://pay.goex.example/CLM-5003",
    lastUpdated: "2025-11-10",
  },
];


const todayISO = () => new Date().toISOString().slice(0, 10);

export default function WarrantiesClaimsView({
}) {

  const [warrantiesData, setWarrantiesData] = useState([]);
  const [loadingWarranties, setLoadingWarranties] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [devices, setDevices] = useState([]);
  const [loadingDevices, setLoadingDevices] = useState(true);
  const Navigate = useNavigate();

  const location = useLocation();

  const [claims, setClaims] = useState([]);
  const [claimsLoading, setClaimsLoading] = useState(true);
  const [claimsPage, setClaimsPage] = useState(1);
  const [claimsTotalPages, setClaimsTotalPages] = useState(1);

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assigningClaim, setAssigningClaim] = useState(null);

  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approvingClaim, setApprovingClaim] = useState(null);
  const [extraPayable, setExtraPayable] = useState(0);
  const [extraReason, setExtraReason] = useState("");
  const [activeTab, setActiveTab] = useState("warranties");
// "warranties" | "claims"

  const [approvalFilter, setApprovalFilter] = useState("all");
  // all | active | provisioning | rejected

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [dashboardStats, setDashboardStats] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(true);

  const retailer_id = location.state?.retailer_id;
  const from_date = location.state?.from_date;
  const to_date = location.state?.to_date;
  const fromActivation = location.state?.fromActivation;

  const approvalParamMap = {
    active: 1,
    provisioning: 0,
    rejected: 2,
  };



  // ⚡ Coming from KPI → showOnlyActive = true
  const showOnlyActive = location.state?.showOnlyActive === true;
  const showOnlyOpen = location.state?.showOnlyOpen === true;
  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

  const userRole = Number(authUser?.role);
  const sessionId = authUser?.id;

  const isAdmin = userRole === 1;
  const isCompany = userRole === 2;

  const ALLOWED_CLAIM_CONSOLE_STATUSES = [
  "device_handover_to_company",
  "company_received_device",
  "device_received_by_company",
];

  const isFinalized = (status) =>
    ["Approved", "Rejected", "Settled"].includes(status);

  const canAssignEmployee = (claim) =>
    claim.status === "Approved" && !claim.assigned_employee;

  useEffect(() => {
    if (showApproveModal) {
      setExtraPayable(0);
      setExtraReason("");
    }
  }, [showApproveModal]);


  // const fetchWarranties = async () => {
  //   try {
  //     setLoadingWarranties(true);

  //     // let url = `${BASE_URL}get-customers?page=${currentPage}`;
  //     let url = `${BASE_URL}warranty/get-customers?page=${currentPage}`;

  //     // 🔹 ROLE-BASED PARAMS
  //     if (userRole === 2 || userRole === 4) {
  //       // Company / Distributor
  //       url += `&company_id=${sessionId}`;
  //     }

  //     if (userRole === 5) {
  //       // Retailer
  //       url += `&retailer_id=${sessionId}`;
  //     }

  //     // ROLE 1 (Admin) → no extra params

  //     const res = await fetch(url);
  //     const data = await res.json();

  //     if (data?.data) {
  //       setTotalPages(data.last_page || 1);

  //       const transformed = data.data.flatMap((customer) =>
  //         customer.devices.map((device) => ({
  //           custid: customer.id,
  //           RawID: device.id,
  //           id: `WAR-${device.id.toString().padStart(4, "0")}`,
  //           retailer: customer.name,
  //           retailerCode: `RET-${customer.id}`,
  //           customer: customer.name,
  //           deviceType: device.product_name || "Device",
  //           brand: device.brand_name || "Brand",
  //           model: device.model || "-",
  //           imei: device.imei1 || "-",
  //           type: "Sold",
  //           is_approved:device.is_approved,
  //           soldOn: device.created_at?.slice(0, 10) || "",
  //           expiry: device.expiry_date || "",
  //           plan: device.product_name || "Warranty",
  //           price: device.device_price || 0,
  //         }))
  //       );

  //       setWarrantiesData(transformed);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch warranties:", error);
  //   } finally {
  //     setLoadingWarranties(false);
  //   }
  // };


  // useEffect(() => {
  //   fetchWarranties();
  // }, [currentPage]); // <-- IMPORTANT

  useEffect(() => {
  if (approvingClaim) {
    setShowApproveModal(true);
  }
}, [approvingClaim]);

useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(search.trim());
  }, 500); // ⏳ debounce delay

  return () => clearTimeout(timer);
}, [search]);


//   const buildDevicesUrl = ({ role, id, page, approvalFilter, search }) => {
//   let url = `${BASE_URL}warranty/get-devices?page=${page}`;

//   // 🔹 ROLE BASED
//   switch (role) {
//     case 2:
//       url += `&company_id=${id}`;
//       break;
//     case 4:
//       url += `&agent_id=${id}`;
//       break;
//     case 5:
//       if (fromActivation && retailer_id) {
//         url += `&retailer_id=${retailer_id}`;
//       } else {
//         url += `&retailer_id=${id}`;
//       }
//       break;
//     case 6:
//       url += `&created_by=${id}`;
//       break;
//     default:
//       break;
//   }

//   // 🔹 STATUS FILTER
//   if (approvalFilter !== "all") {
//     url += `&is_approved=${approvalParamMap[approvalFilter]}`;
//   }

//   // 🔍 SEARCH (only if >= 4 chars)
//   if (search && search.length >= 4) {
//     url += `&search=${encodeURIComponent(search)}`;
//   }

//   if (from_date && to_date) {
//     url += `&from_date=${from_date}&to_date=${to_date}`;
//   }

//   return url;
// };

//   const fetchDevices = async () => {
//   try {
//     setLoadingDevices(true);

//     const url = buildDevicesUrl({
//       role: userRole,
//       id: sessionId,
//       page: currentPage,
//       approvalFilter,
//       search: debouncedSearch, // 👈 important
//     });

//     const res = await fetch(url);
//     const json = await res.json();

//     setDevices(json?.data || []);
//     setTotalPages(json?.last_page || 1);
//   } catch (err) {
//     console.error("Failed to fetch devices", err);
//     setDevices([]);
//   } finally {
//     setLoadingDevices(false);
//   }
// };


const buildDevicesUrl = ({ role, id, page, approvalFilter, search }) => {
  let url = `${BASE_URL}warranty/get-devices?page=${page}`; 

  // 🔹 ROLE BASED
  switch (role) {
    case 2:
      url += `&company_id=${id}`;
      break;

    case 4:
      url += `&agent_id=${id}`;
      break;

    case 5:
      if (fromActivation && retailer_id) {
        url += `&retailer_id=${retailer_id}`;
      } else {
        url += `&retailer_id=${id}`;
      }
      break;

    case 6:
      url += `&created_by=${id}`;
      break;

    default:
      break;
  }

  // 🔹 STATUS FILTER
  if (approvalFilter !== "all") {
    url += `&is_approved=${approvalParamMap[approvalFilter]}`;
  }

  // 🔍 SEARCH (only if >= 4 chars)
  if (search && search.length >= 4) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  if (from_date && to_date) {
    url += `&from_date=${from_date}&to_date=${to_date}`;
  }

  return url;
};

const fetchDevices = async () => {

  try {

    setLoadingDevices(true);

    const url = buildDevicesUrl({
      role: userRole,
      id: sessionId,
      page: currentPage,
      approvalFilter,
      search: debouncedSearch,
    });

    const response = await axios.get(
      url,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const json = response.data;

    setDevices(
      json?.data || []
    );

    setTotalPages(
      json?.last_page || 1
    );

  } catch (err) {

    console.error(
      "Failed to fetch devices",
      err
    );

    setDevices([]);

  } finally {

    setLoadingDevices(false);

  }
};
      
// Reset page when filters/search change
useEffect(() => {
  setCurrentPage(1);
}, [approvalFilter, debouncedSearch, userRole, sessionId]);

// Fetch whenever page or filters change
useEffect(() => {
  fetchDevices();
}, [currentPage, approvalFilter, debouncedSearch, userRole, sessionId]);


  useEffect(() => {
  if (!assigningClaim) return;

  const companyId = assigningClaim.company_id;

  if (!companyId) {
    console.error("Company ID missing in claim", assigningClaim);
    return;
  }

  fetchEmployees(companyId);
}, [assigningClaim]);


  const fetchEmployees = async (companyId) => {

  try {

    setLoadingEmployees(true);

    const response =
      await axios.post(
        `${BASE_URL}company/employee/all`,
        {
          company_id: companyId,
        },
        {
          headers: {
            Accept:
              "application/json",

            "Content-Type":
              "application/json",
          },
        }
      );

    const json =
      response.data;

    // ✅ employees array is nested
    setEmployees(
      json?.data?.data || []
    );

  } catch (err) {

    console.error(
      "Failed to fetch employees",
      err
    );

    setEmployees([]);

  } finally {

    setLoadingEmployees(false);

  }
};

  const openAssignModal = (claim) => {
  setAssigningClaim(claim);
  setSelectedEmployee("");
  setShowAssignModal(true);
  fetchEmployees();
};

  const handleAssignEmployee = async () => {
  if (!assigningClaim || !selectedEmployee) {
    toast.error("Missing claim or employee");
    return;
  }

  const toastId = toast.loading("Assigning employee...");

    try {
      const res = await axios.post(
    `${BASE_URL}warranty/claim/assign-employee`,
    {
      claim_id: assigningClaim.id,
      employee_id: selectedEmployee,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  const json = res.data;

    if (!json?.status) {
      throw new Error(json?.message || "Assignment failed");
    }

    toast.success("Employee assigned successfully", { id: toastId });

    // 🔄 Refresh claims list
    fetchClaims();

    // 🔒 Close modal
    setShowAssignModal(false);
    setAssigningClaim(null);
    setSelectedEmployee(null);
  } catch (err) {
    toast.error(err.message || "Failed to assign employee", {
      id: toastId,
    });
  }
};

const approvalMap = {
  0: { label: "Provisioning", variant: "warning" },
  1: { label: "Active", variant: "success" },
  2: { label: "Rejected", variant: "danger" },
};


  const deviceRows = useMemo(() => {
  return devices.map((d) => {
    const approval = approvalMap[d.is_approved] || {
      label: "Unknown",
      variant: "gray",
    };

    return {
      raw: d,
      cells: [
        {
          title: d.w_code,
          sub: `Sold: ${formatDateTime(d.created_at)}`,
          // extra: `Exp: ${d.expiry_date}`,
        },
        {
          title: d.retailer?.business_name || "—",
          sub: d.customer?.name || "—",
        },
        {
          title: `${d.brand_name}`,
          sub: `Model: ${d.model || "-"}`,
          extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
        },
        {
          // title: d.product_name || "Warranty",
          title: (
            <div className="text-nowrap">
              <p>
                {d.product_name || "Warranty"}
              </p>
              <p>
                {d.product?.product_type || "Warranty"}
              </p>
            </div>
          ),
          sub: d.category_name || "Warranty",
          // extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
        },
        

        <Badge variant={approval.variant}>
          {approval.label}
        </Badge>,
      ],
    };
  });
}, [devices]);

  const fetchClaims = async () => {

  try {

    setClaimsLoading(true);

    let url =
      `${BASE_URL}warranty/claims/list?page=${claimsPage}`;

    if (userRole === 2) {
      url += `&company_id=${sessionId}`;
    }

    const response =
      await axios.get(
        url,
        {
          headers: {
            Accept:
              "application/json",

            "Content-Type":
              "application/json",
          },
        }
      );

    const json =
      response.data;

    if (json?.status) {

      setClaims(
        json?.data?.data || []
      );

      setClaimsTotalPages(
        json?.data?.last_page || 1
      );

    } else {

      setClaims([]);
    }

  } catch (err) {

    console.error(
      "Failed to fetch claims",
      err
    );

    setClaims([]);

  } finally {

    setClaimsLoading(false);

  }
};

  useEffect(() => {
  fetchClaims();
}, [claimsPage, userRole, sessionId]);

  const normalizedClaims = useMemo(() => {
    return claims.map((c) => ({
      // ---------- normalized fields ----------
      code: c.claim_code,
      RawID: c.id,
      status:
    !c.status
      ? "Pending"
      : c.status
          .replaceAll("_", " ")
          .toLowerCase()
          .replace(/\b\w/g, (l) => l.toUpperCase()),
      customer: c.customer?.name || "—",
      device: `${c.device?.product_name || "—"} · ${c.device?.imei1 || "—"}`,
      issue: c.issue_description || "—",
      approvedAmount: Number(c.estimate_amount || 0),
      payableAmount: Number(c.payable_amount || 0),
      lastUpdated: c.updated_at?.slice(0, 10),

      // ---------- 🔥 RAW CLAIM (HIDDEN) ----------
      raw: c,
    }));
  }, [claims]);

  const claimRows = useMemo(() => {
    return normalizedClaims.map((c) => ({
      raw: c.raw, // 🔥 PASS RAW HERE
      cells: [
        {
          title: c.code,
          sub: `Updated: ${c.lastUpdated}`,
        },
        {
          title: c.customer,
          sub: c.device,
        },
        {
          title: c.issue,
        },
        {
          title: `₹ ${formatCurrency(c.approvedAmount)}`,
          sub: `Payable: ₹ ${formatCurrency(c.payableAmount)}`,
        },
        <Badge
          variant={
            c.status === "Rejected"
              ? "danger"
              : c.status === "Pending"
              ? "info"
              : "success"
          }
        >
          {c.status}
        </Badge>,
      ],
    }));
  }, [normalizedClaims]);

  const claimCards = useMemo(() => {
    return normalizedClaims.map((c) => (
      <ExpandableCard
        key={c.id}
        title={c.id}
        badge={{
          label: c.status,
          color:
            c.status === "Approved"
              ? "green"
              : c.status === "Rejected"
              ? "red"
              : "yellow",
        }}
        primaryFields={[
          { label: "Customer", value: c.customer },
          { label: "Device", value: c.device },
          { label: "Issue", value: c.issue },
        ]}
        extraFields={[
          { label: "Warranty", value: c.warrantyId },
          { label: "Approved", value: `₹ ${formatCurrency(c.approvedAmount)}` },
          { label: "Payable", value: `₹ ${formatCurrency(c.payableAmount)}` },
        ]}
        onView={() => setSelectedClaim(c.id)}
      />
    ));
  }, [normalizedClaims]);

  const fetchWarrantyDashboard = async () => {

    try {

      setDashboardLoading(true);

      let url =
        `${BASE_URL}warranty/warranty-dashboard`;

      // ✅ Only company role sends company_id
      if (userRole === 2) {
        url += `?company_id=${sessionId}`;
      }

      const response =
        await axios.get(
          url,
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const json =
        response.data;

      if (!json?.status) {

        throw new Error(
          json?.message ||
          "Failed to fetch dashboard data"
        );
      }

      setDashboardStats(
        json.data
      );

    } catch (err) {

      console.error(
        "Dashboard API error:",
        err
      );

      toast.error(
        err?.response?.data
          ?.message ||
        "Failed to load dashboard stats"
      );

    } finally {

      setDashboardLoading(false);

    }
  };


useEffect(() => {
  if (userRole === 1 || userRole === 2) {
    fetchWarrantyDashboard();
  }
}, [userRole, sessionId]);


  const onPageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // ⚡ Filter logic
  const filteredWarranties = showOnlyActive
    ? warrantiesData.filter((w) => w.status === "Active")
    : warrantiesData;

  const filteredClaims = showOnlyOpen
    ? claims.filter((w) => w.status === "Pending")
    : claims;

  const [claimList, setClaimList] = useState(claims);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const totalApproved = claims.reduce(
    (sum, c) => sum + (c.approvedAmount || 0),
    0
  );
  const totalPayable = claims.reduce(
    (sum, c) => sum + (c.payableAmount || 0),
    0
  );

  // const selectedClaim =
  //   claims.find((c) => c.id === selectedClaimId) || null;

  const handleClaimAction = (id, action) => {
    setClaimList((prev) =>
      prev.map((c) => {
        if (c.id !== id) return c;
        if (action === "approve") {
          return {
            ...c,
            status: "Approved",
            payableStatus: c.payableStatus === "Not Applicable" ? "Pending" : c.payableStatus,
            lastUpdated: todayISO(),
          };
        }
        if (action === "reject") {
          return {
            ...c,
            status: "Rejected",
            payableStatus: "Not Applicable",
            reason: c.reason || "Rejected by admin",
            lastUpdated: todayISO(),
          };
        }
        return c;
      })
    );
  };

  const handleUpdateClaim = (id, updates) => {
      setClaimList((prev) =>
        prev.map((c) => (c.id === id ? { ...c, ...updates, lastUpdated: todayISO() } : c))
      );
    };

    const handleFinalApprove = async () => {
    if (!approvingClaim) return;

    const toastId = toast.loading("Approving claim...");

    try {
      // 🔹 OPTIONAL: API call if backend exists
      // await fetch(`${BASE_URL}warranty/claims/approve`, { ... })

      handleClaimAction(approvingClaim.id, "approve");

      toast.success("Claim approved successfully", { id: toastId });

      setClaims((prev) =>
        prev.map((cl) =>
          cl.id === assigningClaim.raw.id
            ? {
                ...cl,
                assigned_employee: employees.find(
                  (e) => e.id === selectedEmployee
                ),
              }
            : cl
        )
      );
      setShowApproveModal(false);
      setApprovingClaim(null);
    } catch (err) {
      toast.error("Failed to approve claim", { id: toastId });
    }
  };


  const handleApproveClaim = async (claim, reasonId, remark) => {
  const toastId = toast.loading("Approving claim...");

  try {

  const response =
    await axios.post(
      `${BASE_URL}warranty/company/approve-claim`,
      {
        claim_id:
          claim.id,

        reason_id:
          reasonId,

        remark:
          remark || "",
      },
      {
        headers: {
          Accept:
            "application/json",

          "Content-Type":
            "application/json",
        },
      }
    );

  const json =
    response.data;

  if (!json?.status) {

    throw new Error(
      json?.message ||
      "Approve failed"
    );

  }

  toast.success(
    "Claim approved successfully",
    {
      id: toastId,
    }
  );

  // 🔄 Refresh list
  fetchClaims();

  // 🔒 Close modal
  setShowApproveModal(false);

  setApprovingClaim(null);

} catch (err) {

  toast.error(
    err?.response?.data
      ?.message ||
    err?.message ||
    "Failed to approve claim",
    {
      id: toastId,
    }
  );
}
};


const handleRejectClaim = async (
  claim,
  reasonId,
  remark
) => {

  const toastId =
    toast.loading(
      "Rejecting claim..."
    );

  try {

    const response =
      await axios.post(
        `${BASE_URL}warranty/company/reject-claim`,
        {
          claim_id:
            claim.id,

          reason_id:
            reasonId,

          remark:
            remark || "",
        },
        {
          headers: {
            Accept:
              "application/json",

            "Content-Type":
              "application/json",
          },
        }
      );

    const json =
      response.data;

    if (!json?.status) {

      throw new Error(
        json?.message ||
        "Reject failed"
      );

    }

    toast.success(
      "Claim rejected successfully",
      {
        id: toastId,
      }
    );

    // 🔄 Refresh list
    fetchClaims();

    // 🔒 Close modal
    setShowApproveModal(false);

    setApprovingClaim(null);

  } catch (err) {

    toast.error(
      err?.response?.data
        ?.message ||
      err?.message ||
      "Failed to reject claim",
      {
        id: toastId,
      }
    );
  }
};

  const canShowClaimConsole = useMemo(() => {
  if (!selectedClaim?.status) return false;

  const normalizedStatus = String(selectedClaim.status)
    .toLowerCase()
    .replaceAll(" ", "_");

  return ALLOWED_CLAIM_CONSOLE_STATUSES.includes(normalizedStatus);
}, [selectedClaim]);

console.log("selected claim in warranty: ",selectedClaim)

  return (
    <div className="space-y-4">
      <KpiSection
  dashboardStats={dashboardStats}
  loading={dashboardLoading}
  totalApproved={totalApproved}
  totalPayable={totalPayable}
/>


      {/* -------- Tabs -------- */}
      <div className="flex gap-2 border-b border-slate-200">
        <button
          onClick={() => setActiveTab("warranties")}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition
            ${
              activeTab === "warranties"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
        >
          Warranties
        </button>

        <button
          onClick={() => setActiveTab("claims")}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition
            ${
              activeTab === "claims"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
        >
          Claims
        </button>
      </div>


      {activeTab === "warranties" && (
        <WarrantyTable
          showOnlyOpen={showOnlyOpen}
          loadingDevices={loadingDevices}
          deviceRows={deviceRows}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          fetchDevices={fetchDevices}
          Navigate={Navigate}
          approvalFilter={approvalFilter}
          setApprovalFilter={setApprovalFilter}
          search={search}
          setSearch={setSearch}
        />
      )}

      {activeTab === "claims" && (
      <ClaimsTable
        showOnlyActive={showOnlyActive}
        claimsLoading={claimsLoading}
        claimRows={claimRows}
        claimsPage={claimsPage}
        claimsTotalPages={claimsTotalPages}
        setClaimsPage={setClaimsPage}
        setSelectedClaim={setSelectedClaim}
        fetchClaims={fetchClaims}
        claimCards={claimCards}
        setApprovingClaim={setApprovingClaim}
        setShowApproveModal={setShowApproveModal}
        setAssigningClaim={setAssigningClaim}
        setShowAssignModal={setShowAssignModal}
      />
      )}

    {activeTab === "claims" && showApproveModal && approvingClaim && (
        <ApproveRejectModal
          claim={approvingClaim}   // ✅ ALWAYS raw
          isAdmin={isAdmin}
          isCompany={isCompany}
          onClose={() => {
            setShowApproveModal(false);
            setApprovingClaim(null);
          }}
          onAssign={() => {
            setAssigningClaim(approvingClaim);
            setShowApproveModal(false);
          }}

            onApprove={handleApproveClaim}   // ✅
            onReject={handleRejectClaim}
        />
      )}

      {activeTab === "claims" && selectedClaim && canShowClaimConsole && (
        <ClaimConsole
          selectedClaim={selectedClaim}
          setSelectedClaim={setSelectedClaim}
          handleUpdateClaim={handleUpdateClaim}
        />
      )}

      {activeTab === "claims" && selectedClaim && !canShowClaimConsole && (
        <SectionCard title="Claim Handling Console">
          <p className="text-sm text-slate-500">
            Claim actions will be available once the device is handed over to the company.
          </p>
        </SectionCard>
      )}



      {activeTab === "claims" && assigningClaim && (
        <AssignEmployeeModal
          assigningClaim={assigningClaim}
          employees={employees}
          loadingEmployees={loadingEmployees}
          selectedEmployee={selectedEmployee}
          setSelectedEmployee={setSelectedEmployee}
          onAssign={handleAssignEmployee}
          onClose={() => {
            setShowAssignModal(false);
            setAssigningClaim(null);
          }}
        />
      )}

    </div>
  );
}


// import React, { useEffect, useMemo, useState } from "react";
// import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
// import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";


// import {
//   ShieldCheck,
//   FileText,
//   IndianRupee,
//   Edit3,
//   Link2,
//   Eye,
// } from "lucide-react";
// import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";
// import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import RegularLoader from "../../../../Component/Loader/RegularLoader";
// import Pagination from "../../../../Component/Common/Pagination";
// import RefreshButton from "../../../../Component/Common/RefreshButton";
// import { BASE_URL, Warrenty_URL } from "../../../../config/api";
// import SimpleTable from "../../../../Component/Common/SimpleTable";

// import ExpandableCard from "../../../../Component/Common/ExpandableCard";
// import toast from "react-hot-toast";
// import BlueButton from "../../../../Component/Common/BlueButton";
// import KpiSection from "./KpiSection";
// import WarrantyTable from "./WarrantyTable";
// import ClaimsTable from "./ClaimsTable";
// import ClaimConsole from "./ClaimAdminConsole";
// import AssignEmployeeModal from "./AssignEmployeeModal";
// import ApproveRejectModal from "./ApproveRejectModal";
// import { Badge } from "../../../../Component/RetailerMainComponents/Badge";


// const claims = [
//   {
//     id: "CLM-5001",
//     warrantyId: "WAR-1001",
//     retailer: "Shree Mobile Store",
//     customer: "Amit Kulkarni",
//     device: "Samsung A55",
//     raisedBy: "Retailer", // Retailer | Customer
//     issue: "Device not powering on",
//     status: "Pending", // Pending | Approved | Rejected | In Progress | Settled
//     reason: "",
//     approvedAmount: 3500,
//     payableAmount: 3000,
//     payableStatus: "Pending",
//     paymentLink: "",
//     lastUpdated: "2025-10-15",
//   },
//   {
//     id: "CLM-5002",
//     warrantyId: "WAR-0998",
//     retailer: "Digital Zone",
//     customer: "Demo Customer",
//     device: "mPOS Demo",
//     raisedBy: "Customer",
//     issue: "Screen flickering",
//     status: "Rejected",
//     reason: "Warranty expired",
//     approvedAmount: 0,
//     payableAmount: 0,
//     payableStatus: "Not Applicable",
//     paymentLink: "",
//     lastUpdated: "2025-01-07",
//   },
//   {
//     id: "CLM-5003",
//     warrantyId: "WAR-1002",
//     retailer: "A1 Electronics",
//     customer: "Riya Shah",
//     device: "Samsung Tab S9",
//     raisedBy: "Customer",
//     issue: "No sound from speakers",
//     status: "Approved",
//     reason: "",
//     approvedAmount: 2200,
//     payableAmount: 2000,
//     payableStatus: "Paid",
//     paymentLink: "https://pay.goex.example/CLM-5003",
//     lastUpdated: "2025-11-10",
//   },
// ];


// const todayISO = () => new Date().toISOString().slice(0, 10);

// export default function WarrantiesClaimsView({
// }) {

//   const [warrantiesData, setWarrantiesData] = useState([]);
//   const [loadingWarranties, setLoadingWarranties] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const [devices, setDevices] = useState([]);
//   const [loadingDevices, setLoadingDevices] = useState(true);
//   const Navigate = useNavigate();

//   const location = useLocation();

//   const [claims, setClaims] = useState([]);
//   const [claimsLoading, setClaimsLoading] = useState(true);
//   const [claimsPage, setClaimsPage] = useState(1);
//   const [claimsTotalPages, setClaimsTotalPages] = useState(1);

//   const [showAssignModal, setShowAssignModal] = useState(false);
//   const [assigningClaim, setAssigningClaim] = useState(null);

//   const [employees, setEmployees] = useState([]);
//   const [loadingEmployees, setLoadingEmployees] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const [showApproveModal, setShowApproveModal] = useState(false);
//   const [approvingClaim, setApprovingClaim] = useState(null);
//   const [extraPayable, setExtraPayable] = useState(0);
//   const [extraReason, setExtraReason] = useState("");
//   const [activeTab, setActiveTab] = useState("warranties");
// // "warranties" | "claims"


//   // ⚡ Coming from KPI → showOnlyActive = true
//   const showOnlyActive = location.state?.showOnlyActive === true;
//   const showOnlyOpen = location.state?.showOnlyOpen === true;
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const userRole = Number(authUser?.role);
//   const sessionId = authUser?.id;

//   const isAdmin = userRole === 1;
//   const isCompany = userRole === 2;

//   const ALLOWED_CLAIM_CONSOLE_STATUSES = [
//   "device_handover_to_company",
//   "company_received_device",
//   "device_received_by_company",
// ];

//   const isFinalized = (status) =>
//     ["Approved", "Rejected", "Settled"].includes(status);

//   const canAssignEmployee = (claim) =>
//     claim.status === "Approved" && !claim.assigned_employee;

//   useEffect(() => {
//     if (showApproveModal) {
//       setExtraPayable(0);
//       setExtraReason("");
//     }
//   }, [showApproveModal]);


//   const fetchWarranties = async () => {
//     try {
//       setLoadingWarranties(true);

//       // let url = `${BASE_URL}get-customers?page=${currentPage}`;
//       let url = `${BASE_URL}warranty/get-customers?page=${currentPage}`;

//       // 🔹 ROLE-BASED PARAMS
//       if (userRole === 2 || userRole === 4) {
//         // Company / Distributor
//         url += `&company_id=${sessionId}`;
//       }

//       if (userRole === 5) {
//         // Retailer
//         url += `&retailer_id=${sessionId}`;
//       }

//       // ROLE 1 (Admin) → no extra params

//       const res = await fetch(url);
//       const data = await res.json();

//       if (data?.data) {
//         setTotalPages(data.last_page || 1);

//         const transformed = data.data.flatMap((customer) =>
//           customer.devices.map((device) => ({
//             custid: customer.id,
//             RawID: device.id,
//             id: `WAR-${device.id.toString().padStart(4, "0")}`,
//             retailer: customer.name,
//             retailerCode: `RET-${customer.id}`,
//             customer: customer.name,
//             deviceType: device.product_name || "Device",
//             brand: device.brand_name || "Brand",
//             model: device.model || "-",
//             imei: device.imei1 || "-",
//             type: "Sold",
//             is_approved:device.is_approved,
//             soldOn: device.created_at?.slice(0, 10) || "",
//             expiry: device.expiry_date || "",
//             plan: device.product_name || "Warranty",
//             price: device.device_price || 0,
//           }))
//         );

//         setWarrantiesData(transformed);
//       }
//     } catch (error) {
//       console.error("Failed to fetch warranties:", error);
//     } finally {
//       setLoadingWarranties(false);
//     }
//   };


//   useEffect(() => {
//     fetchWarranties();
//   }, [currentPage]); // <-- IMPORTANT

//   useEffect(() => {
//   if (approvingClaim) {
//     setShowApproveModal(true);
//   }
// }, [approvingClaim]);

//   const buildDevicesUrl = ({ role, id, page }) => {
//   let url = `${BASE_URL}warranty/get-devices?page=${page}`;

//   switch (role) {
//     case 2: // company
//       url += `&company_id=${id}`;
//       break;
//     case 4: // agent
//       url += `&agent_id=${id}`;
//       break;
//     case 5: // retailer
//       url += `&retailer_id=${id}`;
//       break;
//     case 6: // created_by
//       url += `&created_by=${id}`;
//       break;
//     // role 1 (admin) → no extra param
//     default:
//       break;
//   }

//   return url;
// };
//   const fetchDevices = async () => {
//   try {
//     setLoadingDevices(true);

//     const url = buildDevicesUrl({
//       role: userRole,
//       id: sessionId,
//       page: currentPage,
//     });

//     const res = await fetch(url);
//     const json = await res.json();

//     setDevices(json?.data || []);
//     setTotalPages(json?.last_page || 1);
//   } catch (err) {
//     console.error("Failed to fetch devices", err);
//     setDevices([]);
//   } finally {
//     setLoadingDevices(false);
//   }
// };

// useEffect(() => {
//   fetchDevices();
// }, [currentPage, userRole, sessionId]);

//   useEffect(() => {
//   if (!assigningClaim) return;

//   const companyId = assigningClaim.company_id;

//   if (!companyId) {
//     console.error("Company ID missing in claim", assigningClaim);
//     return;
//   }

//   fetchEmployees(companyId);
// }, [assigningClaim]);


//   const fetchEmployees = async (companyId) => {
//     try {
//       setLoadingEmployees(true);

//       const res = await fetch(
//         `${BASE_URL}company/employee/all`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             // Authorization header if required
//             // "Authorization": `Bearer ${token}`,
//           },
//           body: JSON.stringify({
//             company_id: companyId, // ✅ FROM CLAIM ROW
//           }),
//         }
//       );

//       const json = await res.json();

//       // ✅ IMPORTANT: employees array is nested
//       setEmployees(json?.data?.data || []);
//     } catch (err) {
//       console.error("Failed to fetch employees", err);
//       setEmployees([]);
//     } finally {
//       setLoadingEmployees(false);
//     }
//   };

//   const openAssignModal = (claim) => {
//   setAssigningClaim(claim);
//   setSelectedEmployee("");
//   setShowAssignModal(true);
//   fetchEmployees();
// };

//   const handleAssignEmployee = async () => {
//   if (!assigningClaim || !selectedEmployee) {
//     toast.error("Missing claim or employee");
//     return;
//   }

//   const toastId = toast.loading("Assigning employee...");

//   try {
//     const res = await fetch(
//       `${BASE_URL}warranty/claim/assign-employee`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           claim_id: assigningClaim.id,       // ✅ numeric backend ID
//           employee_id: selectedEmployee,     // ✅ selected employee
//         }),
//       }
//     );

//     const json = await res.json();

//     if (!json?.status) {
//       throw new Error(json?.message || "Assignment failed");
//     }

//     toast.success("Employee assigned successfully", { id: toastId });

//     // 🔄 Refresh claims list
//     fetchClaims();

//     // 🔒 Close modal
//     setShowAssignModal(false);
//     setAssigningClaim(null);
//     setSelectedEmployee(null);
//   } catch (err) {
//     toast.error(err.message || "Failed to assign employee", {
//       id: toastId,
//     });
//   }
// };

// const approvalMap = {
//   0: { label: "Provisioning", variant: "warning" },
//   1: { label: "Active", variant: "success" },
//   2: { label: "Rejected", variant: "danger" },
// };


//   const deviceRows = useMemo(() => {
//   return devices.map((d) => {
//     const approval = approvalMap[d.is_approved] || {
//       label: "Unknown",
//       variant: "gray",
//     };

//     return {
//       raw: d,
//       cells: [
//         {
//           title: d.w_code,
//           sub: `Sold: ${d.created_at?.slice(0, 10)}`,
//           // extra: `Exp: ${d.expiry_date}`,
//         },
//         {
//           title: d.customer?.retailer?.business_name || "—",
//           sub: d.customer?.name || "—",
//         },
//         {
//           title: `${d.brand_name}`,
//           sub: `Model: ${d.model || "-"}`,
//           // extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
//         },
//         {
//           title: d.product_name || "Warranty",
//           sub: d.category_name || "Warranty",
//           // extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
//         },
        

//         <Badge variant={approval.variant}>
//           {approval.label}
//         </Badge>,
//       ],
//     };
//   });
// }, [devices]);

//   const fetchClaims = async () => {
//   try {
//     setClaimsLoading(true);

//     let url = `${BASE_URL}warranty/claims/list?page=${claimsPage}`;

//     if (userRole === 2) {
//       url += `&company_id=${sessionId}`;
//     }

//     const res = await fetch(url);
//     const json = await res.json();

//     if (json?.status) {
//       setClaims(json.data?.data || []);
//       setClaimsTotalPages(json.data?.last_page || 1);
//     } else {
//       setClaims([]);
//     }
//   } catch (err) {
//     console.error("Failed to fetch claims", err);
//     setClaims([]);
//   } finally {
//     setClaimsLoading(false);
//   }
// };

//   useEffect(() => {
//   fetchClaims();
// }, [claimsPage, userRole, sessionId]);

//   const normalizedClaims = useMemo(() => {
//     return claims.map((c) => ({
//       // ---------- normalized fields ----------
//       code: c.claim_code,
//       RawID: c.id,
//       status:
//     !c.status
//       ? "Pending"
//       : c.status
//           .replaceAll("_", " ")
//           .toLowerCase()
//           .replace(/\b\w/g, (l) => l.toUpperCase()),
//       customer: c.customer?.name || "—",
//       device: `${c.device?.product_name || "—"} · ${c.device?.imei1 || "—"}`,
//       issue: c.issue_description || "—",
//       approvedAmount: Number(c.estimate_amount || 0),
//       payableAmount: Number(c.payable_amount || 0),
//       lastUpdated: c.updated_at?.slice(0, 10),

//       // ---------- 🔥 RAW CLAIM (HIDDEN) ----------
//       raw: c,
//     }));
//   }, [claims]);

//   const claimRows = useMemo(() => {
//     return normalizedClaims.map((c) => ({
//       raw: c.raw, // 🔥 PASS RAW HERE
//       cells: [
//         {
//           title: c.code,
//           sub: `Updated: ${c.lastUpdated}`,
//         },
//         {
//           title: c.customer,
//           sub: c.device,
//         },
//         {
//           title: c.issue,
//         },
//         {
//           title: `₹ ${formatCurrency(c.approvedAmount)}`,
//           sub: `Payable: ₹ ${formatCurrency(c.payableAmount)}`,
//         },
//         <Badge
//           variant={
//             c.status === "Rejected"
//               ? "danger"
//               : c.status === "Pending"
//               ? "info"
//               : "success"
//           }
//         >
//           {c.status}
//         </Badge>,
//       ],
//     }));
//   }, [normalizedClaims]);

//   const claimCards = useMemo(() => {
//     return normalizedClaims.map((c) => (
//       <ExpandableCard
//         key={c.id}
//         title={c.id}
//         badge={{
//           label: c.status,
//           color:
//             c.status === "Approved"
//               ? "green"
//               : c.status === "Rejected"
//               ? "red"
//               : "yellow",
//         }}
//         primaryFields={[
//           { label: "Customer", value: c.customer },
//           { label: "Device", value: c.device },
//           { label: "Issue", value: c.issue },
//         ]}
//         extraFields={[
//           { label: "Warranty", value: c.warrantyId },
//           { label: "Approved", value: `₹ ${formatCurrency(c.approvedAmount)}` },
//           { label: "Payable", value: `₹ ${formatCurrency(c.payableAmount)}` },
//         ]}
//         onView={() => setSelectedClaim(c.id)}
//       />
//     ));
//   }, [normalizedClaims]);

//   const onPageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   // ⚡ Filter logic
//   const filteredWarranties = showOnlyActive
//     ? warrantiesData.filter((w) => w.status === "Active")
//     : warrantiesData;

//   const filteredClaims = showOnlyOpen
//     ? claims.filter((w) => w.status === "Pending")
//     : claims;

//   const [claimList, setClaimList] = useState(claims);
//   const [selectedClaim, setSelectedClaim] = useState(null);
//   const totalApproved = claims.reduce(
//     (sum, c) => sum + (c.approvedAmount || 0),
//     0
//   );
//   const totalPayable = claims.reduce(
//     (sum, c) => sum + (c.payableAmount || 0),
//     0
//   );

//   // const selectedClaim =
//   //   claims.find((c) => c.id === selectedClaimId) || null;

//   const handleClaimAction = (id, action) => {
//     setClaimList((prev) =>
//       prev.map((c) => {
//         if (c.id !== id) return c;
//         if (action === "approve") {
//           return {
//             ...c,
//             status: "Approved",
//             payableStatus: c.payableStatus === "Not Applicable" ? "Pending" : c.payableStatus,
//             lastUpdated: todayISO(),
//           };
//         }
//         if (action === "reject") {
//           return {
//             ...c,
//             status: "Rejected",
//             payableStatus: "Not Applicable",
//             reason: c.reason || "Rejected by admin",
//             lastUpdated: todayISO(),
//           };
//         }
//         return c;
//       })
//     );
//   };

//   const handleUpdateClaim = (id, updates) => {
//       setClaimList((prev) =>
//         prev.map((c) => (c.id === id ? { ...c, ...updates, lastUpdated: todayISO() } : c))
//       );
//     };

//     const handleFinalApprove = async () => {
//     if (!approvingClaim) return;

//     const toastId = toast.loading("Approving claim...");

//     try {
//       // 🔹 OPTIONAL: API call if backend exists
//       // await fetch(`${BASE_URL}warranty/claims/approve`, { ... })

//       handleClaimAction(approvingClaim.id, "approve");

//       toast.success("Claim approved successfully", { id: toastId });

//       setClaims((prev) =>
//         prev.map((cl) =>
//           cl.id === assigningClaim.raw.id
//             ? {
//                 ...cl,
//                 assigned_employee: employees.find(
//                   (e) => e.id === selectedEmployee
//                 ),
//               }
//             : cl
//         )
//       );
//       setShowApproveModal(false);
//       setApprovingClaim(null);
//     } catch (err) {
//       toast.error("Failed to approve claim", { id: toastId });
//     }
//   };


//   const handleApproveClaim = async (claim, reasonId, remark) => {
//   const toastId = toast.loading("Approving claim...");

//   try {
//     const res = await fetch(
//       `${BASE_URL}warranty/company/approve-claim`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           claim_id: claim.id,
//           reason_id: reasonId,
//           remark: remark || "",
//         }),
//       }
//     );

//     const json = await res.json();

//     if (!json?.status) {
//       throw new Error(json?.message || "Approve failed");
//     }

//     toast.success("Claim approved successfully", { id: toastId });

//     // 🔄 Refresh list
//     fetchClaims();

//     // 🔒 Close modal
//     setShowApproveModal(false);
//     setApprovingClaim(null);
//   } catch (err) {
//     toast.error(err.message || "Failed to approve claim", {
//       id: toastId,
//     });
//   }
// };


// const handleRejectClaim = async (claim, reasonId, remark) => {
//   const toastId = toast.loading("Rejecting claim...");

//   try {
//     const res = await fetch(
//       `${BASE_URL}warranty/company/reject-claim`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           claim_id: claim.id,
//           reason_id: reasonId,
//           remark: remark || "",
//         }),
//       }
//     );

//     const json = await res.json();

//     if (!json?.status) {
//       throw new Error(json?.message || "Reject failed");
//     }

//     toast.success("Claim rejected successfully", { id: toastId });

//     // 🔄 Refresh list
//     fetchClaims();

//     // 🔒 Close modal
//     setShowApproveModal(false);
//     setApprovingClaim(null);
//   } catch (err) {
//     toast.error(err.message || "Failed to reject claim", {
//       id: toastId,
//     });
//   }
// };

//   const canShowClaimConsole = useMemo(() => {
//   if (!selectedClaim?.status) return false;

//   const normalizedStatus = String(selectedClaim.status)
//     .toLowerCase()
//     .replaceAll(" ", "_");

//   return ALLOWED_CLAIM_CONSOLE_STATUSES.includes(normalizedStatus);
// }, [selectedClaim]);

// console.log("selected claim in warranty: ",selectedClaim)

//   return (
//     <div className="space-y-4">
//       <KpiSection
//         warrantiesData={warrantiesData}
//         claims={claims}
//         totalApproved={totalApproved}
//         totalPayable={totalPayable}
//       />

//       {/* -------- Tabs -------- */}
//       <div className="flex gap-2 border-b border-slate-200">
//         <button
//           onClick={() => setActiveTab("warranties")}
//           className={`px-4 py-2 text-sm font-medium border-b-2 transition
//             ${
//               activeTab === "warranties"
//                 ? "border-blue-600 text-blue-600"
//                 : "border-transparent text-slate-500 hover:text-slate-700"
//             }`}
//         >
//           Warranties
//         </button>

//         <button
//           onClick={() => setActiveTab("claims")}
//           className={`px-4 py-2 text-sm font-medium border-b-2 transition
//             ${
//               activeTab === "claims"
//                 ? "border-blue-600 text-blue-600"
//                 : "border-transparent text-slate-500 hover:text-slate-700"
//             }`}
//         >
//           Claims
//         </button>
//       </div>


//       {activeTab === "warranties" && (
//         <WarrantyTable
//           showOnlyOpen={showOnlyOpen}
//           loadingDevices={loadingDevices}
//           deviceRows={deviceRows}
//           currentPage={currentPage}
//           totalPages={totalPages}
//           setCurrentPage={setCurrentPage}
//           fetchDevices={fetchDevices}
//           Navigate={Navigate}
//         />
//       )}

//       {activeTab === "claims" && (
//       <ClaimsTable
//         showOnlyActive={showOnlyActive}
//         claimsLoading={claimsLoading}
//         claimRows={claimRows}
//         claimsPage={claimsPage}
//         claimsTotalPages={claimsTotalPages}
//         setClaimsPage={setClaimsPage}
//         setSelectedClaim={setSelectedClaim}
//         fetchClaims={fetchClaims}
//         claimCards={claimCards}
//         setApprovingClaim={setApprovingClaim}
//         setShowApproveModal={setShowApproveModal}
//         setAssigningClaim={setAssigningClaim}
//         setShowAssignModal={setShowAssignModal}
//       />
//       )}

//      {activeTab === "claims" && showApproveModal && approvingClaim && (
//         <ApproveRejectModal
//           claim={approvingClaim}   // ✅ ALWAYS raw
//           isAdmin={isAdmin}
//           isCompany={isCompany}
//           onClose={() => {
//             setShowApproveModal(false);
//             setApprovingClaim(null);
//           }}
//           onAssign={() => {
//             setAssigningClaim(approvingClaim);
//             setShowApproveModal(false);
//           }}

//             onApprove={handleApproveClaim}   // ✅
//             onReject={handleRejectClaim}
//         />
//       )}

//       {activeTab === "claims" && selectedClaim && canShowClaimConsole && (
//         <ClaimConsole
//           selectedClaim={selectedClaim}
//           setSelectedClaim={setSelectedClaim}
//           handleUpdateClaim={handleUpdateClaim}
//         />
//       )}

//       {activeTab === "claims" && selectedClaim && !canShowClaimConsole && (
//         <SectionCard title="Claim Handling Console">
//           <p className="text-sm text-slate-500">
//             Claim actions will be available once the device is handed over to the company.
//           </p>
//         </SectionCard>
//       )}



//       {activeTab === "claims" && assigningClaim && (
//         <AssignEmployeeModal
//           assigningClaim={assigningClaim}
//           employees={employees}
//           loadingEmployees={loadingEmployees}
//           selectedEmployee={selectedEmployee}
//           setSelectedEmployee={setSelectedEmployee}
//           onAssign={handleAssignEmployee}
//           onClose={() => {
//             setShowAssignModal(false);
//             setAssigningClaim(null);
//           }}
//         />
//       )}

//     </div>
//   );
// }
